<template>
  <div :class="['editing-area']">
    <div v-if="images.length" :class="['composite-image']" :style="{width: images[0].width + 'px', height: images[0].height + 'px'}">
      <ul>
        <li v-for="(image, index) in images" :key="index" :hidden="image.hidden">
          <img
            :width="image.width"
            :height="image.height"
            :data-index="image.index"
            :src="image.url"
            :style="{mixBlendMode: image.mixBlendMode, filter: image.filtersString}" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EditingArea',
  props: {
    images: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style>
.editing-area
{
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  top: 0;
  left: 0;
  border: solid var(--em-1) var(--dark);
  box-shadow: 0 0 var(--em-2) var(--darkest) inset;
}

.composite-image
{
  top: 50%;
  left: 50%;
  position: absolute;
  transform-origin: left top;
  overflow: hidden;
  box-shadow: 0 0 var(--em-8) var(--darkest);
  transition: var(--ease-in-out-back);
}

.composite-image img
{
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/editing-area.vue